// extracted by mini-css-extract-plugin
export default {"footer":"C-DKm2YrQb","language":"U+79YTqijW","language-dropdown":"_6fS+rueTqB","languageDropdown":"_6fS+rueTqB","transparent":"poQWNDo3Lj","footer-section":"HzmFJ7OHVI","footerSection":"HzmFJ7OHVI","interactive":"ql7N3owZg-","right":"rUogGwfunb","link":"ZQVf6-g5M5","copyright-links":"f+JX6IJzoZ","copyrightLinks":"f+JX6IJzoZ","left":"_37Md7EvilQ","footer-section-button":"ceHuqQ8KwP","footerSectionButton":"ceHuqQ8KwP","primary":"rN4hXcH435"};
    if(module.hot) {
      // 1643570356340
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  